/* eslint-disable class-methods-use-this */
import DirectoryService from './DirectoryService';

class MicrosoftCustomDirectoryService implements DirectoryService {
  constructor(scopes: string[]) {
    this.scopes = scopes;
  }

  private scopes: string[];

  readonly name = 'Microsoft';

  canChangeRsvp = () => this.scopes.includes('Calendars.ReadWrite');

  showEmployeeDirectoryIntegrationErrorInOrgCalendarPreference = () => true;
}

export default MicrosoftCustomDirectoryService;
